// import composables
import { useFetch } from '@vueuse/core';
import useAuth from '@/composables/useAuth/useAuth';
import { useLoaderStore } from '@/store/loaderStore';

// import types
import FetchArgs from '@/composables/useApi/types/FetchArgs';
import FetchOptions from '@/composables/useApi/types/FetchOptions';

export default function useApi() {
  const createFetchOptions = (
    endpoint: {
      path: string;
      method: 'GET' | 'PUT' | 'POST' | 'DELETE';
      requireAuth: boolean;
    },
    args?: FetchArgs
  ): FetchOptions => {
    const baseOptions: FetchOptions = {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
      },
    };

    if (args) {
      return {
        ...baseOptions,
        method: endpoint.method,
        headers: {
          ...baseOptions.headers,
          Authorization: endpoint.requireAuth
            ? 'Bearer ' + useAuth().getToken
            : '',
        },
        body: args,
      };
    } else {
      return {
        ...baseOptions,
        method: endpoint.method,
        headers: {
          ...baseOptions.headers,
          Authorization: endpoint.requireAuth
            ? 'Bearer ' + useAuth().getToken
            : '',
        },
      };
    }
  };

  const fetchData = (
    baseUrl: string,
    endpoint: {
      path: string;
      method: 'GET' | 'PUT' | 'POST' | 'DELETE';
      requireAuth: boolean;
    },
    args?: FetchArgs
  ) => {
    const loaderStore = useLoaderStore();
    const fetchOptions = createFetchOptions(endpoint, args);
    const url = `${baseUrl}${endpoint.path}`;

    // Use fetchArgs as the process name if available, otherwise fallback to endpoint path
    const processName = args ? JSON.stringify(args) : endpoint.path;

    // Start tracking loading state
    loaderStore.startLoading(processName);

    const fetchRequest = useFetch(url, {
      method: fetchOptions.method,
      headers: fetchOptions.headers,
      body: fetchOptions.body ? JSON.stringify(fetchOptions.body) : undefined,
    });

    fetchRequest.onFetchResponse((response) => {
      // Handle response
    });

    fetchRequest.onFetchError((error) => {
      console.error('Fetch error:', error);
    });

    fetchRequest.onFetchFinally(() => {
      // Stop loading once the fetch is complete
      loaderStore.stopLoading(processName);
    });

    return fetchRequest;
  };

  return {
    fetchData,
  };
}
